/* eslint-disable @next/next/no-img-element */
import MainLayout from 'layouts/MainLayout';

import HeroSection from './views/HeroSection';
import BenefitsSection from './views/BenefitsSection';
import CatalogSection from './views/CatalogSection';
import BundlesSection from './views/BundlesSection';
import useGlobalStore from 'stores/global-store.store';

const ZoomLP = () => {
  const { isFixedAlertFraudImageVisible } = useGlobalStore();

  return (
    <MainLayout isHeaderFull>
      <HeroSection />

      <BenefitsSection />

      <BundlesSection />

      <CatalogSection />

      <div
        className={`fixed ${
          isFixedAlertFraudImageVisible
            ? 'bottom-[75px] sm:bottom-[85px] md:bottom-[100px] lg:bottom-[115px] xl:bottom-[150px]'
            : 'bottom-5'
        } right-5 z-10`}
      >
        <button
          className="flex items-center gap-[7px] bg-theme-primary-main px-5 py-2.5 rounded-[50px] text-base font-medium text-white shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]"
          onClick={() =>
            window.open(
              'https://api.whatsapp.com/send/?phone=6281196308597&text=Halo%20admin%20Xooply%2C%0A%0ASaya%20ingin%20mengajukan%20permintaan%20produk%20zoom.%0A%0ATerima%20kasih',
            )
          }
        >
          Ajukan Permintaan
          <img
            alt="zoom-logo-white"
            src="https://storage.googleapis.com/xooply-assets/cp/zoom/zoom-logo-white.png"
            className="h-[15px]"
          />
        </button>
      </div>
    </MainLayout>
  );
};

export default ZoomLP;
